<template>
  <b-modal size="lg" v-model="visible" title="Przypisz temat" @ok="onOk" @show="onShow">
    <b-form @submit.prevent="onSubmit">
      <b-form-group class="required" label="Temat">
        <multiselect
          v-model="item"
          track-by="id"
          label="title"
          placeholder="Wybierz szablon tematu"
          :options="items"
          :loading="searching"
          @search-change="onSearch"
          @open="onSearch"
          :internal-search="false"
          :searchable="true"
          :allow-empty="false"
        >
          <template slot="singleLabel" slot-scope="{option}">
            <span>{{option.title}}</span>
          </template>
        </multiselect>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import { axios, eventBus } from "@/_infrastructure";
import { required } from "vuelidate/lib/validators";
import multiselect from "vue-multiselect";

export default {
  components: {
    multiselect
  },
  data() {
    return {
      item: null,
      items: [],
      searching: false,
      visible: false
    };
  },
  validations: {
    item: { required }
  },
  methods: {
    show() {
      this.visible = true;
    },
    onShow() {
      this.$v.$reset();
      this.item = null;
    },

    onSearch(searchClause) {
      this.searching = true;

      axios
        .get("/templateSubjects", {
          params: {
            sortBy: "title",
            title: searchClause,
            sortDesc: false,
            perPage: 20,
            currentPage: 1
          }
        })
        .then(response => {
          var result = response.data;
          this.items = result.rows;
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          this.searching = false;
        });
    },
    onOk(e) {
      e.preventDefault();
      this.onSubmit();
    },
    onSubmit() {
      this.$v.$touch();

      if (!this.$v.$error) {
        this.$emit("save", this.item.id);
        this.visible = false;
      }
    }
  }
};
</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
</style>

